import { CarFront, TrafficCone } from 'lucide-react'
import type { NavSection } from '../../core/router/navConfig'

/** Navegação da área Abastecimento (27/10/2026): o setor de combustível, que o
 *  cliente chama de Controle de Informação, lança as multas de trânsito e, desde
 *  01/11/2026, os sinistros, e eles caem no DP, que só lê. O relatório de Abastecimentos
 *  continua na Logística.
 *
 *  Entrar na área não dá a tela: cada uma pede a própria key, que chega pelo cargo. Ver
 *  docs/areas/05-como-adicionar.md. */
export const abastecimentoNav: NavSection[] = [
  {
    title: 'Lançamentos',
    titleKey: 'nav.section.fuelEntries',
    items: [
      { label: 'Multas', labelKey: 'nav.fines', path: '/abastecimento/multas', icon: TrafficCone, ready: true, permission: 'multa.view' },
      { label: 'Sinistros', labelKey: 'nav.claims', path: '/abastecimento/sinistros', icon: CarFront, ready: true, permission: 'sinistro.view' },
    ],
  },
]
